/*
  CRO 16 Sep 2026 — one-tap size add on product cards.

  Two jobs only:
  1. The "Quick add" button on a card opens/closes that card's size row.
  2. A size chip writes its variant id into the card form's hidden id input.

  The chip is a real submit button, so after this listener runs the browser submits the
  form and Dawn's <product-form> takes over — cart drawer, the cart app's listeners and
  error handling all behave exactly as a normal add to cart. Click listeners run before
  the form's default submit, so the id is always set in time.

  Delegated from document so it works for cards rendered later (pagination, filters,
  section re-renders) without re-binding.

  CAPTURE PHASE, deliberately. Something else on the page — the cart app, which listens on
  button[name="add"] — stops the click before it bubbles to document, then adds whatever the
  form currently holds. In the bubble phase this listener never ran and every chip added the
  default size. Capture runs top-down before any of that, so the variant id is always set first.
*/
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-card-sizes-toggle]');
  if (toggle) {
    const row = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!row) return;
    const isOpen = !row.hidden;
    row.hidden = isOpen;
    toggle.setAttribute('aria-expanded', String(!isOpen));
    if (!isOpen) row.querySelector('.card-sizes__chip:not([disabled])')?.focus();
    return;
  }

  const chip = event.target.closest('.card-sizes__chip');
  if (!chip || chip.disabled) return;
  const input = chip.closest('form')?.querySelector('input[name="id"]');
  if (input && chip.dataset.variantId) {
    input.value = chip.dataset.variantId;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}, true);
